import styled from 'styled-components';
export const Content = styled.div `
  padding: var(--space-400) 0;
`;
export const SectionsContainer = styled.div `
  margin-bottom: var(--space-600);
`;
export const SectionsHeader = styled.h3 `
  margin: 0 0 var(--space-400) 0;
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
`;
export const SectionsList = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
export const SectionCard = styled.div `
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  padding: var(--space-400);
  background-color: var(--bg-secondary);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
export const SectionInfo = styled.div `
  flex: 1;
`;
export const SectionName = styled.div `
  font-weight: var(--font-weight-semibold);
  margin-bottom: var(--space-100);
  color: var(--text-primary);
`;
export const SectionDescription = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  margin-bottom: var(--space-200);
`;
export const SectionUrl = styled.div `
  color: var(--text-brand);
  font-size: var(--font-size-300);
  word-break: break-all;
`;
export const FormHeader = styled.h4 `
  margin: 0 0 var(--space-400) 0;
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
`;
export const FormActions = styled.div `
  display: flex;
  gap: var(--space-200);
  justify-content: flex-end;
`;
export const EmptyState = styled.div `
  text-align: center;
  padding: var(--space-800) var(--space-400);
  color: var(--text-secondary);
  font-size: var(--font-size-300);
`;
// Settings section styled components
export const SettingsSection = styled.div `
  margin-top: var(--space-600);
  padding-top: var(--space-600);
  border-top: 1px solid var(--border-primary);
`;
export const SettingsHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-400);
`;
export const SettingsTitle = styled.h4 `
  margin: 0;
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
`;
export const SettingsList = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
export const SettingItem = styled.div `
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  padding: var(--space-400);
  background-color: var(--bg-secondary);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
export const SettingInfo = styled.div `
  flex: 1;
`;
export const SettingName = styled.div `
  font-weight: var(--font-weight-semibold);
  margin-bottom: var(--space-100);
  color: var(--text-primary);
`;
export const SettingType = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  text-transform: uppercase;
  margin-bottom: var(--space-100);
`;
export const SettingDefault = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
`;
export const SettingActions = styled.div `
  display: flex;
  gap: var(--space-200);
`;
export const EmptySettings = styled.div `
  text-align: center;
  padding: var(--space-800) var(--space-400);
  color: var(--text-secondary);
`;
export const EmptySettingsText = styled.div `
  font-size: var(--font-size-300);
  margin-bottom: var(--space-100);
`;
export const EmptySettingsSubtext = styled.div `
  font-size: var(--font-size-200);
  color: var(--icon-secondary);
`;
export const SettingsModalContent = styled.div `
  padding: var(--space-400) 0;
`;
export const DisabledSettingsTooltip = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-100);
  cursor: not-allowed;
  height: 100%;
  color: var(--icon-secondary);
`;
